// 9fbef606107a605d69c0edbcd8029e5d
import Styled, { css } from 'styled-components';
import { IMG_BASE_DIMENTION } from '../../plpTileConstants';

export const HeroTile = Styled.div`
  display: flex;
  grid-column: span 2;
  flex-direction: column;
  box-sizing: content-box;
  justify-self: center;
  text-align: left;
  isolation: isolate;
  background-color: ${(props) => props.theme.colors.WHITE};
  height: 100%;
  .atb-icon-image {
    @media ${(props) => props.theme.mediaQuery.small} {
      height: 42px;
    }
    @media ${(props) => props.theme.mediaQuery.mediumOnly} {
      height: 51px;
    }
    @media ${(props) => props.theme.mediaQuery.large} {
      height: 51px;
    }
  }

  &.slp-tile {
    width: 100%;
  }

  :hover .interactive-color-swatches-arrow-toggle {
    transform: rotate(180deg);
  }

  :hover .interactive-color-swatch-container {
    display: flex;
  }

  @media ${(props) => props.theme.mediaQuery.large} {
    :hover .reveal-atb-button {
      max-height: 51px;
      padding: 0;
      opacity: 1;
    }

    &:not(:hover) .reveal-atb-button {
      border: unset;
      transition: border 0.4s ease-in-out;
    }
  }
    .product-swatch-atb{
    margin-top:12px;
    @media ${(props) => props.theme.mediaQuery.large} {
    ${(props) => (props.isInteractiveColorSwatchBandEnabled ? 'margin-top:0px;' : '')}
    }
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    align-self: stretch;
    }
`;

export const ColorSwatchWrapper = Styled.div`
height: 16px;
${(props) => (props?.isSlp && props?.isTileRedesignAB === 'variationB' ? 'height:0;' : '')}
${(props) =>
  props?.hplp ? `margin-bottom: ${props.theme.spacing.ELEM_SPACING.XS_6};` : 'margin-bottom:8px;'}
  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    ${(props) => (props?.isSlp && props?.isTileRedesignAB === 'variationB' ? 'height:1px;' : '')}
   }
   @media ${(props) => props.theme.mediaQuery.large} {
    ${(props) => (props.isPlp ? `margin-bottom: ${props.theme.spacing.ELEM_SPACING.SM};` : '')}
   }
`;

export const Divider = Styled.div`
  height: ${(props) => (props?.isTileRedesignAB ? '' : `${props.height || 8}`)}px;
`;

export const HorizontalLineDivider = Styled.div`
  width: 100%;
  height: 0px;
  border-top: 1px solid #cfcfcf;

  flex: none;
  order: 1;
  flex-grow: 0;
  margin: 0px 0px 10px 0px;
`;

export default css`
  .vm-5 {
    margin: 5px 0;
  }
  .mt-5 {
    margin-top: 5px;
  }
  .relative {
    position: relative;
  }
  .top-badge-container {
    position: absolute;
    bottom: 0px;
    right: 0;
    transform: translateY(50%);
    ${(props) => props?.isTileRedesignAB && `min-height: ${props.theme.spacing.ELEM_SPACING.MED};`};
  }
  .top-badge-container span:last-child {
    margin-right: 0;
  }
  .ht-25 {
    height: 25px;
  }
  .product-title-hlp {
    margin-bottom: 8px;
  }
  .product-title-hlp.tile-redesign {
    margin-bottom: unset;
  }
  a {
    text-decoration: none;
  }
  .flex-row {
    display: flex;
    flex-direction: row;
  }
  .atb-icon-parent {
    position: relative;
  }
  .alt-plp-flex-row {
    display: flex;
  }
  .alt-plp-flex-row-bundle {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
  }
  .flex-end {
    justify-content: flex-end;
  }
  .justify-between {
    justify-content: space-between;
  }
  .product-image {
    width: 100%;
    height: 0;
    padding-top: ${Math.ceil(
      (IMG_BASE_DIMENTION.baseHeight / IMG_BASE_DIMENTION.baseWidth) * 100
    )}%;
    position: relative;
    img {
      height: 100%;
      width: 100%;
      object-fit: contain;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
    }
  }
  .alt-product-image {
    width: 100%;
    height: 227px;
    @media (min-width: 321px) {
      height: 254px;
    }
    @media (min-width: 351px) {
      height: 319px;
    }
    @media (min-width: 425px) {
      height: 335px;
    }
    @media (min-width: 451px) {
      height: 410px;
    }
    @media (min-width: 551px) {
      height: 478px;
    }
    @media (min-width: 634px) {
      height: 299px;
    }
    @media (min-width: 801px) {
      height: 385px;
    }
    @media (min-width: 1041px) {
      height: 297px;
    }
    @media (min-width: 1201px) {
      height: 268px;
    }
    @media (min-width: 1441px) {
      height: 344px;
    }
    @media (min-width: 1880px) {
      height: 416px;
    }
    @media (min-width: 2200px) {
      height: 437px;
    }
    @media (min-width: 2300px) {
      height: 450px;
    }
    @media (min-width: 2450px) {
      height: 485px;
    }
    position: relative;
    img {
      height: 100%;
      width: 100%;
      object-fit: contain;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
    }
  }
  .price-list {
    width: 80%;
    height: 47px;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      height: 39px;
    }
  }
  .price-promotion-class {
    margin-top: 4px;
  }
  .price-list.tile-redesign {
    height: unset;
    margin-top: 0;

    ${(props) =>
      props.setPLPSLPAddToCartCTA !== 'icon'
        ? `display: flex;
        align-items: center;
        flex-wrap: wrap;
        @media ${props.theme.mediaQuery.smallOnly} {
        align-items: flex-start;
        width:100%;
      }
      `
        : ''}
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      height: unset;
    }
  }
  .offer-price {
    padding-right: ${(props) => props.theme.spacing.ELEM_SPACING.XS};
    line-height: 1em;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      line-height: 1em;
      padding-right: ${(props) => props.theme.spacing.ELEM_SPACING.XXS};
    }
  }
  .striked-price {
    line-height: 0;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      line-height: 0;
      padding-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.XXXS};
    }
  }
  .atb-icon-parent .price-list {
    width: 80%;
    margin-top: 0;
    height: auto;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      height: 39px;
    }
  }
  .fav-heart-svg {
    width: 20px;
    @media ${(props) => props.theme.mediaQuery.large} {
      width: 24px;
    }
  }
  .fav-new-svg {
    z-index: 1;
    width: 30px;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    box-sizing: border-box;
    background: rgba(255, 255, 255, 0.9);
    border-radius: 22px;
    padding-top: 2.5px;
    border: 1px solid ${(props) => props.theme.colors.PRIMARY.LIGHTERGRAY};

    @media ${(props) => props.theme.mediaQuery.large} {
      width: 36px;
      height: 36px;
    }
    :hover {
      .empty-favorite-2 {
        fill: ${(props) => props.theme.colors.NOTIFICATION.ERROR};
        stroke: ${(props) => props.theme.colors.NOTIFICATION.ERROR};
        stroke-linecap: round;
        stroke-linejoin: round;
      }
    }
  }

  .fav-svg-heart {
    @media ${(props) => props.theme.mediaQuery.mediumMax} {
      width: 18px;
      height: 16px;
    }
  }
  .alt-plp-price-list {
    width: 80%;
    height: 40px;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    gap: 16px;
    align-items: baseline;
    margin-top: 6px;
  }
  .alt-plp-price-list-bundle {
    width: 80%;
    height: 40px;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    gap: 16px;
    align-items: baseline;
    margin-top: 9px;
  }
  .price-list.bundle-price {
    margin-bottom: 4px;
  }
  && .image-tile-border {
    border: 1px solid ${(props) => props.theme.colors.PRIMARY.LIGHTGRAY};
    object-fit: cover;
  }
  .hlp-tile-price-wishlist .price-list {
    display: inline-flex;
    height: auto;
    margin-bottom: 4px;
  }

  .hlp-tile-price-wishlist .price-list span:last-child {
    padding-top: 5px;
    padding-left: 8px;
  }

  .hlp-tile-price-wishlist .price-list span:first-child {
    ${(props) =>
      props.isTileRedesignAB &&
      ` padding-left: 0px;
    padding-top: 0px;`}
  }

  .swatch-end {
    display: inline-block;
    height: 1px;
    width: 1px;
  }

  .rr-colorswatch {
    @media ${(props) => props.theme.mediaQuery.small} {
      width: 115px;
    }
    @media ${(props) => props.theme.mediaQuery.medium} {
      width: 142px;
    }
  }
  .rr-colorswatch.empty {
    height: 30px;
    @media ${(props) => props.theme.mediaQuery.mediumOnly} {
      height: 25px;
    }
  }
  .rr-colorswatch.non-empty {
    margin-bottom: 18px;
  }

  .rr-colorswatch.non-empty.color-swatch-class {
    margin-bottom: 0px;
  }

  .rr-colorswatch.atb-btn-class.non-empty {
    margin-bottom: 0px;
  }
  .color-swatch-container,
  .color-swatch-container-hlp {
    max-width: 100%;
    min-height: 16px;
    font-size: 0;
  }
  .color-swatch-container-hlp {
    margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.XS};
    @media ${(props) => props.theme.mediaQuery.mediumMax} {
      margin-bottom: 4px;
    }
  }
  .color-swatch-container-hlp.tile-redesign {
    margin-bottom: 0px;
  }
  .color-swatch-container,
  .color-swatch-container-alt-plp {
    max-width: 100%;
    min-height: 26px;
    font-size: 0;
  }
  .with-btn-class {
    height: 40px;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      height: 10px;
    }
    @media ${(props) => props.theme.mediaQuery.mediumOnly} {
      height: 10px;
    }
  }
  .color-swatch-list {
    padding: 0;
    box-sizing: border-box;
    margin: 1px 0px;
    ${(props) =>
      props?.isTileRedesignAB === 'variationA'
        ? 'display: flex; align-items: center;'
        : 'display: block;'}
    overflow-x: scroll;
    overflow-y: hidden;
    white-space: nowrap;
    -ms-overflow-style: none;
    scrollbar-width: none;
    width: 100%;
    &::-webkit-scrollbar {
      display: none;
    }
  }
  .alt-plp-color-swatch-list {
    padding: 0;
    box-sizing: border-box;
    margin: 1px 0px;
    display: flex;
    align-items: center;
    overflow-x: scroll;
    overflow-y: hidden;
    white-space: nowrap;
    -ms-overflow-style: none;
    scrollbar-width: none;
    width: 100%;
    &::-webkit-scrollbar {
      display: none;
    }
  }
  .interactive-color-swatches-image-container {
    margin-bottom: 12px;
  }
`;
